import { takeLatest, call, put } from 'redux-saga/effects'
import getGeneral from 'api/general/get'
import * as fromActions from '../../actions/general.action'

async function getList() {
  return getGeneral()
}

function* getSettingsGeneralListEffectSaga() {
  try {
    const { data } = yield call(getList)
    yield put(fromActions.Actions.getSuccess(data))
  } catch (error) {
    yield put(fromActions.Actions.setLoading(false))
    console.log('error: ', error)
  }
}

export function* getSettingsGeneralListWatcherSaga() {
  yield takeLatest(
    fromActions.GENERAL_CONFIG_GET,
    getSettingsGeneralListEffectSaga
  )
}
